import * as SystemOfUnits from '@/lib/system-of-units'
import GnssStatus from './gnss-status'
import store from '@/store'
import i18n from '@/lib/i18n'

const camelCaseKeys = require('camelcase-keys')
const convertUnits = require('convert-units')

export default class NaviRealtimeInfo {
  constructor(jsonString) {
    if (jsonString) {
      this.jsonObject = {}
      const parsed = JSON.parse(jsonString)
      const keys = Object.keys(parsed)
      for (let i = 0; i < keys.length; i++) {
        const key = keys[i]
        if (key !== 'attributes') {
          this.jsonObject[key] = parsed[key]
        }
      }
      this.jsonObject = camelCaseKeys(this.jsonObject, { deep: true })

      const attributes = parsed.attributes
      this.attributeMap = {}
      for (let i = 0; i < attributes.length; i++) {
        const attr = parsed.attributes[i]
        this.attributeMap[attr.name] = { unit: attr.unit, value: attr.value }
        this.attributeMap = camelCaseKeys(this.attributeMap, { deep: true })
      }
    }
  }

  getDeviceId() {
    return this.jsonObject.deviceId
  }

  getGeoInfoKey() {
    return this.jsonObject.geoInfoKey
  }

  getTrackKey() {
    return this.jsonObject.trackKey
  }

  getPosition() {
    return [this.jsonObject.geoPoint.latLonPoint.lon, this.jsonObject.geoPoint.latLonPoint.lat]
  }

  getXYZPosition() {
    return [
      this.jsonObject.geoPoint.latLonPoint.lon,
      this.jsonObject.geoPoint.latLonPoint.lat,
      this.jsonObject.geoPoint.latLonPoint.z,
    ]
  }

  getUsername() {
    return this.jsonObject.username
  }

  getWorkWidth() {
    return this.attributeMap.workWidth.value
  }

  getWorkWidthUnit() {
    return this.attributeMap.workWidth.unit
  }

  getLeftWorkWidth() {
    const workWidth = this.getWorkWidth()
    return workWidth / 2
  }

  getRightWorkWidth() {
    const workWidth = this.getWorkWidth()
    return workWidth / 2
  }

  getWorkWidthForDisplay() {
    const width = this.getWorkWidth()
    const unit = this.getWorkWidthUnit()
    if (SystemOfUnits.isMetric()) {
      //AgriBus-NAVIからは m で送られてくるので、そのまま返却
      return this.round(width) + ' ' + unit
    } else {
      const targetUnit = 'ft'
      const value = convertUnits(width)
        .from(unit)
        .to(targetUnit)
      return this.round(value) + ' ' + targetUnit
    }
  }

  getSpeed() {
    return this.attributeMap.speed.value
  }

  getSpeedUnit() {
    return this.attributeMap.speed.unit
  }

  getSpeedForDisplay() {
    const speed = this.getSpeed()
    const unit = this.getSpeedUnit()
    let targetUnit = 'km/h'
    const speedKph = convertUnits(speed)
      .from(unit)
      .to(targetUnit)
    if (SystemOfUnits.isMetric()) {
      return this.round(speedKph) + ' ' + targetUnit
    } else {
      targetUnit = 'mph'
      const speedMph = convertUnits(speedKph)
        .from('km')
        .to('mi')
      return this.round(speedMph) + ' ' + targetUnit
    }
  }

  getRotation() {
    let rotation = this.getHeading() * -1
    return rotation
  }

  getHeading() {
    const heading = this.attributeMap.heading.value
    return this.round(heading)
  }

  getHeight() {
    const height = this.attributeMap.height.value
    return this.round(height)
  }

  getHeightUnit() {
    return this.attributeMap.height.unit
  }

  getHeightForDisplay() {
    const width = this.getHeight()
    const unit = this.getHeightUnit()
    if (SystemOfUnits.isMetric()) {
      //AgriBus-NAVIからは m で送られてくるので、そのまま返却
      return this.round(width) + ' ' + unit
    } else {
      const targetUnit = 'ft'
      const value = convertUnits(width)
        .from(unit)
        .to(targetUnit)
      return this.round(value) + ' ' + targetUnit
    }
  }

  getGnssNumOfSats() {
    return this.attributeMap.gnssNumOfSats.value
  }

  getGnssStatusText() {
    const gnssStatus = this.attributeMap.gnssStatus.value
    return GnssStatus.getTextFromInteger(gnssStatus)
  }

  getGnssStatusBackgroundColor() {
    const gnssStatus = this.attributeMap.gnssStatus.value
    return GnssStatus.getLightColorFromInteger(gnssStatus)
  }

  getCovered() {
    return this.jsonObject.covered
  }

  getCoveredForDisplay() {
    const covered = this.getCovered()
    const fieldKey = this.getFieldKey()
    let f = this.getField(fieldKey)
    if (f && covered) {
      return f.name + ' ' + this.round(covered) + ' %'
    }
    return i18n.tt('customNowProgressRateNotField')
  }

  getFieldKey() {
    return this.jsonObject.fieldKey
  }

  getField(fieldKey) {
    let f = store.getters.fields.filter(f => f.geoInfoKey === fieldKey)
    if (f.length > 0) {
      return f[0]
    }
    return null
  }

  round(value) {
    return Math.round(value * 10) / 10
  }
}
